import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-table-service',
  templateUrl: './our-table-service.component.html',
  styleUrls: ['./our-table-service.component.scss']
})
export class OurTableServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
